import { render } from "./TvmMyAddress.vue?vue&type=template&id=4d6ade4c&scoped=true"
import script from "./TvmMyAddress.vue?vue&type=script&lang=js"
export * from "./TvmMyAddress.vue?vue&type=script&lang=js"

import "./TvmMyAddress.vue?vue&type=style&index=0&id=4d6ade4c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6ade4c"],['__file',"src/Components/ChatWidget/TvmMyAddress/TvmMyAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6ade4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6ade4c', __exports__)) {
    api.reload('4d6ade4c', __exports__)
  }
  
  module.hot.accept("./TvmMyAddress.vue?vue&type=template&id=4d6ade4c&scoped=true", () => {
    api.rerender('4d6ade4c', render)
  })

}


export default __exports__